<div class="table-section">
  <h1 translate>{{formType}}</h1>
  <form [formGroup]="form" class="mb-4">
    <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
  </form>
</div>